import React, { useId, useMemo } from 'react';
import Icd10Picker from './Icd10Picker';
import { formatIcd10Entry, icd10FromField } from '../../utils/icd10Entries';

interface ICDSelectProps {
  /** Stored assessment value: "G40.909 - Epilepsy, unspecified, …" ('' when empty) */
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  invalid?: boolean;
  /** Entry strings already chosen (e.g. the secondary list), not selectable again */
  exclude?: string[];
  id?: string;
}

/**
 * Assessment ICD-10 field: Icd10Picker over the full code set, keeping the stored
 * "CODE - description" string that the CMS-485 and claims read (diagnosisExtraction.js).
 */
const ICDSelect: React.FC<ICDSelectProps> = ({ value, onChange, placeholder, className = '', disabled = false, invalid = false, exclude = [], id }) => {
  const autoId = useId();
  const picked = useMemo(() => icd10FromField(value), [value]);
  const excludeCodes = useMemo(() => exclude.map((e) => icd10FromField(e)?.code).filter((c): c is string => !!c), [exclude]);
  return (
    <Icd10Picker
      id={id || `icd-${autoId}`}
      value={picked}
      onChange={(code) => onChange(code ? formatIcd10Entry(code) : '')}
      placeholder={placeholder}
      disabled={disabled}
      invalid={invalid}
      excludeCodes={excludeCodes}
      className={className}
    />
  );
};

export default ICDSelect;
